module.exports = __webpack_public_path__ + "static/logo-7bc4aeb64267b7fb95e1e0ecdaa5a363.svg";